module.exports = __webpack_public_path__ + "static/media/finance-capital-structure.e3e6b231.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/finance-capital-structure.mp4
// module id = 1055
// module chunks = 0